export const API_URL = "https://api.magatra.site/api";
export const siteUrl = "https://magatra.site";
export const attendanceOptions = {
    1: "Hadir",
    0: "Tidak hadir",
    2: "Masih ragu"
}

export const bankIconSvg = {
    "bca": "bca.svg",
    "bpd-bali": "bpd-bali.svg",
    // Add more bank icons as needed
};